import { cn } from '@/lib/utils';
import { X } from 'lucide-react';

interface FilterPillProps {
  label: string;
  active?: boolean;
  disabled?: boolean;
  onToggle?: () => void;
  onRemove?: () => void;
  showRemove?: boolean;
  className?: string;
}

export function FilterPill({
  label,
  active = false,
  disabled = false,
  onToggle,
  onRemove,
  showRemove = false,
  className,
}: FilterPillProps) {
  const handleClick = () => {
    if (disabled) return;
    if (showRemove && onRemove) {
      onRemove();
    } else if (onToggle) {
      onToggle();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={cn(
        'inline-flex h-9 items-center gap-1.5 rounded-md px-3 py-0 text-sm font-medium transition-colors',
        'border focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1',
        active
          ? 'bg-primary text-primary-foreground border-primary hover:bg-primary/90'
          : 'bg-background text-foreground border-border hover:bg-secondary',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      <span>{label}</span>
      {showRemove && active && (
        <X className="h-3 w-3" />
      )}
    </button>
  );
}
